import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Label } from 'jbc-front/components/presenters/form/Label';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { Input } from 'jbc-front/components/presenters/form/Input';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import type { Schema } from '../../schema';

export const EmployeesCount: FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<Schema>();

  return (
    <Panel>
      <Headding>労働者数</Headding>
      <Item>
        <div>
          <Label>在籍労働者数</Label>
          <Spacer size={8} />
          <Input {...register('enrolledEmployeesCount')} />
          {errors.enrolledEmployeesCount?.message && (
            <ErrorMessage>{errors.enrolledEmployeesCount.message}</ErrorMessage>
          )}
        </div>

        <div className="u-mt20">
          <Label>受診労働者数</Label>
          <Spacer size={8} />
          <Input {...register('checkedEmployeesCount')} />
          {errors.checkedEmployeesCount?.message && <ErrorMessage>{errors.checkedEmployeesCount.message}</ErrorMessage>}
        </div>
      </Item>
    </Panel>
  );
};
